import React from 'react'
import { observer } from 'mobx-react'
import { useWillClearConstrainOnUnmount, useWillConstrain } from '@morningtrain/react-filters'
import useCart from 'services/cart/hooks/use-cart'
import difference from 'lodash/difference'

function CartFilter (props) {
  useWillClearConstrainOnUnmount(props.name)

  const [ids, setIds] = React.useState([])

  useWillConstrain('ids', ids)

  const cart = useCart()
  const cartIds = Object.keys(cart.toJSON())

  /// Add non-existing ID if card is empty
  /// This will make sure that no domains are returned from the server
  /// It is a hack to get no domains back when we else would get all
  /// There is no pagination, so it could potentially be a lot
  if (cartIds.length < 1) {
    cartIds.push(0)
  }

  React.useEffect(() => {
    if (difference(cartIds, ids).length > 0 || difference(ids, cartIds).length > 0) {
      setIds(cartIds)
    }
  })

  return null
}

export default observer(CartFilter)
